import React, { useState } from 'react';

const WalletConnection = ({
    userAccount,
    hasActiveAccount,
    onConnect,
    onUnlock,
    onDisconnect,
    accountData,
    provider,
    currentChainId,
    onSelectWallet,
    /** Freighter/Hana: connected with no ethers Web3Provider — not "locked". */
    activeWalletOrigin = null,
}) => {
    const [copied, setCopied] = useState(false);

    const handleConnectClick = async () => {
        // Use the onConnect prop to open the shared modal from App.js
        if (onConnect) {
            onConnect();
        }
    };
    
    const isStellarExtension = [
        'freighter',
        'hana',
        'xbull',
        'lobstr',
        'albedo',
        'rabet',
        'stellar',
    ].includes(activeWalletOrigin);
    // Locked = EVM-style: have address but no signer provider. Stellar extensions never set `provider`.
    const isWalletLocked = Boolean(userAccount && !provider && !isStellarExtension);
    
    const formatAddress = (address) => {
        return `${address.slice(0, 6)}...${address.slice(-4)}`;
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }).catch(err => {
            console.error('Failed to copy: ', err);
        });
    };

    const handleAddressClick = () => {
        if (userAccount) {
            copyToClipboard(userAccount);
        }
    };

    return (
        <div className="wallet-connection">
            {userAccount ? (
                <div className="wallet-bar">
                    <button
                        type="button"
                        className="wallet-address-button"
                        onClick={handleAddressClick}
                        title="Click to copy address"
                    >
                        <span className="wallet-address-text">
                            {formatAddress(userAccount)}
                        </span>
                        {copied ? (
                            <i className="fas fa-check" style={{ color: 'var(--success-color)', fontSize: '12px' }} />
                        ) : (
                            <i className="fas fa-copy" style={{ fontSize: '12px', opacity: 0.6 }} />
                        )}
                    </button>

                    {isWalletLocked ? (
                        <button className="connect-button" onClick={onUnlock || onConnect}>Unlock Wallet</button>
                    ) : (
                        <button className="disconnect-button" onClick={onDisconnect}>Disconnect</button>
                    )}
                </div>
            ) : (
                <button className="connect-button" onClick={handleConnectClick}>Connect</button>
            )}
        </div>
    );
};

export default WalletConnection;